<template>
  <div class="fpr__bg" v-if="fillProfileOpen" @click="closeFillProfile">
    <div class="fpr__modal" @click.stop>
      <div class="fpr__top">
        <img src="/static/img/ic_close.svg" class="fpr__close" @click="closeFillProfile">
        <img src="/static/img/note.svg" class="fpr__ill">
        <div class="fpr__reward">+10</div>
        <p class="fpr__heading">Давай знакомиться ближе!</p>
        <p class="fpr__desc">Заполни анкету и получи 10 баллов!</p>
        <div class="fpr__button" @click="onButtonClicked">Заполнить анкету</div>
      </div>
      <div class="fpr__bottom">*Обязательно для перехода на 3-й уровень</div>
    </div>
  </div>
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    fillProfileOpen: function () {
      return Store.state.fillProfileOpen
    }
  },
  methods: {
    openFillProfile: function () {
      Store.commit('openFillProfile')
    },
    closeFillProfile: function () {
      Store.commit('closeFillProfile')
    },
    onButtonClicked: function () {
      this.$router.push('/profile')
      this.closeFillProfile()
    }
  },
  created: function () {
    window.openFillProfile = this.openFillProfile
  }
}
</script>



// WEBPACK FOOTER //
// fill-profile.vue?5dd17e3a